import { useId } from "react";

import styled from "styled-components/macro";

/* Household versions of fa-user-plus, fa-user-pen and fa-address-card -- FA 7
   has none of the three. Drawn off FA 7's own outlines (solid house, and the
   plus, pen and card out of the duotone font), with the house standing in
   where the person was, so they sit beside the stock glyphs at the same
   weight.

   1em and currentColor like an fa icon, and the light layer reads
   --fa-secondary-opacity the way fa-duotone's does, so whatever sets that on
   a duotone icon sets it on these too. */

const HOUSE =
  "M278 9C266 -3 247 -3 234 9L10 217C1 226 -3 240 2 252C7 264 19 272 32 272H48V448C48 483 77 512 112 512H400C435 512 464 483 464 448V272H480C493 272 505 264 510 252C515 240 511 226 502 217L278 9Z M240 320H272C299 320 320 342 320 368V464H192V368C192 342 214 320 240 320Z";
const PLUS =
  "M568 120C568 107 557 96 544 96C531 96 520 107 520 120V168H472C459 168 448 179 448 192C448 205 459 216 472 216H520V264C520 277 531 288 544 288C557 288 568 277 568 264V216H616C629 216 640 205 640 192C640 179 629 168 616 168H568V120Z";
const PEN =
  "M320 527 332 467C335 455 341 443 350 434L469 315L549 395L430 514C421 523 410 529 397 532L338 544C337 544 336 544 335 544C327 544 320 537 320 529C320 528 320 527 320 526Z M571 373 491 293 520 264C542 242 578 242 600 264C622 286 622 322 600 344L571 373Z";
// the card with its person taken out, so the house can go where she was
const CARD =
  "M0 96V416C0 451 29 480 64 480H512C547 480 576 451 576 416V96C576 61 547 32 512 32H64C29 32 0 61 0 96Z M336 168C336 155 347 144 360 144H472C485 144 496 155 496 168C496 181 485 192 472 192H360C347 192 336 181 336 168Z M336 264C336 251 347 240 360 240H472C485 240 496 251 496 264C496 277 485 288 472 288H360C347 288 336 277 336 264Z";

// the gap fa-user-pen leaves between the pen and the person, in glyph units
const PEN_GAP = 56;

const secondary = { opacity: "var(--fa-secondary-opacity, 0.4)" };

export function HouseholdSignedUp() {
  return (
    <Glyph viewBox="0 0 640 512">
      <path
        d={HOUSE}
        transform="translate(0 64) scale(0.875)"
        style={secondary}
      />
      <path d={PLUS} />
    </Glyph>
  );
}

export function HouseholdUpdated() {
  const maskID = useId();
  return (
    <Glyph viewBox="0 0 640 512">
      <mask
        id={maskID}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="640"
        height="576"
      >
        <rect width="640" height="576" fill="#fff" />
        <path
          d={PEN}
          fill="#000"
          stroke="#000"
          strokeWidth={PEN_GAP}
          strokeLinejoin="round"
        />
      </mask>
      {/* masked from outside the transform, or the cut scales with the house */}
      <g mask={`url(#${maskID})`}>
        <path
          d={HOUSE}
          transform="translate(0 64) scale(0.875)"
          style={secondary}
        />
      </g>
      <path d={PEN} />
    </Glyph>
  );
}

export function HouseholdDataEntry() {
  return (
    <Glyph viewBox="0 0 576 512">
      <path d={CARD} style={secondary} />
      <path d={HOUSE} transform="translate(56 144) scale(0.46875)" />
    </Glyph>
  );
}

/* overflow: the pen's tip hangs below the em box, same as it does in the font */
const Glyph = styled.svg.attrs({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": true,
  focusable: false,
})`
  display: inline-block;
  height: 1em;
  overflow: visible;
  fill: currentColor;
  vertical-align: -0.125em;
`;
